var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      "data-clazz": _vm.model.clazz
    }
  }, [_c("div", {
    staticClass: "panelTitle"
  }, [_vm._v(_vm._s(_vm.i18n["timerEvent"]))]), _c("div", {
    staticClass: "panelBody"
  }, [_c("DefaultDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v(_vm._s(_vm.i18n["timerEvent.cycle"]) + "：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      type: "textarea",
      rows: 4,
      disabled: _vm.readOnly,
      value: _vm.model.cycle
    },
    on: {
      input: function input(value) {
        _vm.onChange("cycle", value);
      }
    }
  })], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v(_vm._s(_vm.i18n["timerEvent.duration"]) + "：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      type: "textarea",
      rows: 4,
      disabled: _vm.readOnly,
      value: _vm.model.duration
    },
    on: {
      input: function input(value) {
        _vm.onChange("duration", value);
      }
    }
  })], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v("视图文件路径（以view开头）")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      disabled: _vm.readOnly,
      placeholder: "请输入视图文件路径（以view开头）",
      type: "view",
      value: _vm.model.view
    },
    on: {
      input: function input(value) {
        _vm.onChange("view", value);
      }
    }
  })], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v("步骤：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      disabled: _vm.readOnly,
      value: _vm.model.step,
      placeholder: "请输入步骤"
    },
    on: {
      input: function input(value) {
        _vm.onChange("step", value);
      }
    }
  })], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };